import $ from 'jquery';

import { Dialog } from 'material-ui';
import moment from 'moment';
import { saveActivity } from '../../common/commonService.js'
import React from 'react';
import { apiService } from '../../common/apiCallService';
import { baseUrl } from '../../common/config';
import MessageList from "./MessageList";
import NewMessage from "./NewMessage";
import './MyGameMessanger.css';
import MessageInformation from "./MessageInformation";
import { parse } from "papaparse";
import Loading from '../Loading';


let filter = [
    { key: 'All', value: 'All' },
    { key: 'Published', value: 'Published' },
    { key: 'Expired', value: 'Expired' },
    { key: 'Not Published', value: 'Not Published' }]


let messageConfig = [
    {
        heading: 'Render To', selectedConfig: 'Live Feed', dropBox: 'renderTo',
        configList: [
            { key: 'Live feed', value: 'Live feed' },
            { key: 'Whiz chat feed', value: 'Whiz chat feed', active: true, }]
    },
    {
        heading: 'Notification Style', selectedConfig: 'Fade out', dropBox: 'notificationStyle',
        configList: [
            { key: 'Fade out', value: 'Fade out', active: false },
            { key: 'In-feed', value: 'In-feed', active: false }]
    }
]
let timeData = [
    {
        heading: 'Scheduled date (optional)',
        selectedConfig: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
        dropBox: 'publishedOn', active: true,
    },
    {
        heading: 'Expiry date (optional)',
        selectedConfig: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
        dropBox: 'expiredOn', active: false
    }
]
class MyGameMessenger2 extends React.Component {
    constructor(props) {
        super(props);
        this.initialState = {
            messenger: { page: 'chat' },
            showDatePicker: false,
            view: 'form',
            accountNameList: [],
            accountNames: '',
            selectedStatus: 'All',
            openDropBox: false,
            messageStatusDropBox: false,
            renderToDropBox: false,
            scheduleTODropBox: false,
            newMessage: false,
            showMessageinfo: false,
            selectedMessage: {},
            publishedOn: moment().utc().format("DD.MM.YYYY hh:mm:ss"),
            expiredOn: moment().utc().add(1, 'Day').format("DD.MM.YYYY hh:mm:ss"),
            renderTo: 'Live Feed',
            notificationStyle: 'Fade out',
            message: '',
            backClick: false,
            pageNumber: 0,
            pageCount: 30,
            messangerList: [],
            componentLoad: false,
            loading: false,
            fileName:'',
            notificationStyleDropBox: false,
            messageConfig,
            timeData,
            messageSend: false
        }
        // props.nextPage(pageNumber + 1
        this.state = {
            ...this.initialState
        }

    }

    componentDidMount() {
        this.getMessageInfo()
    }
    componentDidUpdate() {
        // let { showMessageinfo, newMessage, backClick, componentLoad } = this.state
        // console.log("showMessageinfo, newMessage.....", $('.modal').hasClass('in'), showMessageinfo, newMessage)
        // if (!showMessageinfo && !newMessage && !backClick && !componentLoad && $('.modal').hasClass('in')) {
        //     console.log("componentDidUpdate.....MyGameMessenger2")
        //     // this.getMessageInfo()
        //     // limit: 5, offset: 5 * pageNumber,

        // }

    }
    componentWillReceiveProps(nextProps) {
        if (this.props.open != nextProps.open && nextProps.open)
            this.getMessageInfo()
    }

    getMessageInfo = async (pageNumber = 0, messageStatus = this.state.selectedStatus) => {
        this.setState({ loading: true })
        await apiService(`${baseUrl}/whizEvent/getMygameMessengerList`,
            {
                status: this.state.selectedStatus,
                getTotalCount: !this.state.componentLoad,
                messageStatus,
                limit: 9, offset: 9 * pageNumber,
            }
            , (messages) => {
                let data = messages.msgList
                for (let i = 0; i < data.length; i++) {
                    data[i].accountName = data[i].playersList.slice(0, 100).toString()
                    data[i].dateCreated = `${moment(data[i].createdAt).format("DD.MM.YYYY")} | ${moment(data[i].createdAt).format("hh:mm")}`
                    console.log(moment(data[i].publishedOn).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                        moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                        moment(data[i].publishedOn).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") > moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"), "|||||||",
                        moment(data[i].publishedOn).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") < moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"))
                    if (moment(data[i].publishedOn).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") < moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"))
                        data[i].status = 'Published'
                    if (moment(data[i].expiredOn).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") < moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"))
                        data[i].status = 'Expired'
                    if (moment(data[i].publishedOn).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") > moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"))
                        data[i].status = 'Not Published'
                }
                this.setState({ messangerList: data, componentLoad: true, pageCount: messages.total, pageNumber, loading: false })

                // setTimeout(() => {
                //     this.setState({ view: 'form', messenger: { page: 'chat' } })
                //     this.props.handleClose()
                // }, 5000)
                // return data
            }, (error) => {
                this.setState({ loading: false })
                console.log("Error:", error)
            })
    }

    closeMyGameMessanger = () => {
        this.setState({ ...this.initialState })
        this.props.handleClose(false)
    }

    handleInputChange = e => {
        const { messenger } = this.state
        messenger[e.target.name] = e.target.value
        this.setState({ messenger, showDatePicker: e.target.name === 'scheduleTime' })
    }

    onMessageChange = (e) => {
       this.setState({ message: e.target.value })
    }

    onAccountNameChanges = (e) => {
        this.setState({ accountNames: e.target.value })
    }

    saveMessageConfiguration = () => {
        this.setState({ loading: true })
        let author = localStorage.getItem('accountName') === null || localStorage.getItem('accountName') === undefined
            ? (localStorage.getItem('first_name')).concat(` ${localStorage.getItem("last_name")}`)
            : localStorage.getItem('accountName')
        let { accountNames, accountNameList, renderTo, notificationStyle, publishedOn, expiredOn, message } = this.state
        let notifyUsers = []
        if (renderTo === '') {
            renderTo = messageConfig[0].selectedConfig
        }
        if (notificationStyle === '') {
            notificationStyle = messageConfig[0].selectedConfig
        }
        notifyUsers = ((accountNames.split(',')).concat(accountNameList)).filter(obj => obj !== '')
        if (notifyUsers.length === 0)
            alert("Add acount name")
        else if (message === '')
            alert("Add Message")
        let messenger = { notifyUsers, renderTo, notificationStyle, publishedOn, expiredOn, message, author }
        apiService(`${baseUrl}/whizEvent/sendMessageToPlayer`, messenger, (data) => {
            this.setState({ messageSend: true, loading: false })
            setTimeout(() => {
                // this.setState({ ...this.initialState})
                this.setState({ messageSend: false })
                // $('.modal').removeClass('in');
                // $('.modal').attr("aria-hidden","true");
                // $('.modal').css("display", "none");
                // $('.modal-backdrop').remove();
                // $('body').removeClass('modal-open');
                $(".btn-closeMessanger").click();
                this.setState({ ...this.initialState })
                this.props.handleClose(false)
                // $("#mygamemessenger").modal("toggle")
                // $("#mygamemessenger .close").click();
                // $('#mygamemessenger').modal('hide')
                // this.props.handleClose()
            }, 5000)
            // return data
        }, (error) => {
            this.setState({ loading: false })
            console.log("Error:", error)
        })
    }

    sendMessage = () => {
        const { messenger, scheduleTimeError } = this.state
        let track = {}
        track.hit_page = 'MyGameMessenger';
        track.hit_type = 'SendMessage';
        track.hit_attribute1 = localStorage.getItem("username");
        track.hit_attribute2 = messenger.accountName;
        track.hit_attribute3 = messenger.page;
        track.hit_attribute4 = messenger.message;
        track.hit_player = messenger.accountName;
        saveActivity(track);


        if (Object.keys(messenger).length < 3 || scheduleTimeError) {
            return
        }
        apiService(`${baseUrl}/whizEvent/sendMessageToPlayer`, messenger, (data) => {
            this.setState({ view: 'done' })
            setTimeout(() => {
                this.setState({ view: 'form', messenger: { page: 'chat' } })
                $("#mygamemessenger .close").click();
            }, 5000)
            return data
        }, (error) => {
            this.setState({ loading: false })
            console.log("Error:", error)
        })
    }
    messageinfo = (e, data) => {
        e.preventDefault();
        this.setState({ showMessageinfo: true, selectedMessage: data })
    }
    goBack = () => {
        this.setState({ newMessage: false, showMessageinfo: false, backClick: true })
    }
    clickOutside = (e, data) => {

        let dataValue = e.target.getAttribute('data-value')

        if (dataValue !== 'mg-browse-file') {
            e.preventDefault();


            if (dataValue !== 'mg-dropdown') {
                this.setState({ openDropBox: false })
            };
            if (dataValue !== 'mg-createMsg-dropdown') {
                this.setState({ notificationStyleDropBox: false, renderToDropBox: false })
            };

            // this.setState({ openDropBox: false })
        }


    };
    createNewMessage = () => {
        this.setState({
            newMessage: true,
            accountNameList: [],
            accountNames: '',
            publishedOn: moment().utc().format("DD.MM.YYYY hh:mm:ss"),
            expiredOn: moment().utc().add(1, 'Day').format("DD.MM.YYYY hh:mm:ss"),
            renderTo: '',
            notificationStyle: '',
            message: '',
        })
    }
    openDropDown = (e, dropBox) => {
        this.setState({ openDropBox: true, [`${dropBox}`]: true })
        // setOpenDropDown(true)
        // setActiveDroxKey(data.key)
    }
    setSelectedValue = (e, data) => {
        e.stopPropagation();
        if (data.dropBox) {
            let messageConfig = this.state.messageConfig
            messageConfig.filter(obj => obj.dropBox === data.dropBox)[0].selectedConfig = data.key
            this.setState({ messageConfig, [`${data.dropBox}DropBox`]: false, [data.dropBox]: data.key })

        } else {
            this.setState({ selectedStatus: data.key })
            this.setState({ openDropBox: false })
            this.getMessageInfo(0, data.key)
        }

        // setDropDownSelected(true)
        // TransferHeader.filter(obj => obj.key === data.key)[0].selectedValue = option.key
        // setTransferHeaders(TransferHeader)
        // setOpenDropDown(false)
    }

    onDropFiles = (e) => {
        e.preventDefault();
        this.convertCsvToJSON(e.dataTransfer.files)
        // setHighlighted(false);
    }

    nextPage = (pageNumber) => {
        // let pageNumber = this.state.pageNumber
        this.getMessageInfo(pageNumber)
    }
    convertCsvToJSON = (files) => {
        Array.from(files)
            .filter((file) => file.type === "text/csv")
            .forEach(async (file) => {
                const text = await file.text();
                const result = parse(text, { header: false });
                this.setState({fileName:file.name})
                this.setState({ accountNameList: result.data.flat().filter(obj => obj !== '') })
                // setContacts((existing) => [...existing, ...result.data]);
            });
    }
    handleUpload = (e) => {
        this.convertCsvToJSON(e.target.files)
    }

    // getAsText(fileToRead) {
    //     console.log("getAsText..............")
    //     var reader = new FileReader();
    //     // Read file into memory as UTF-8      
    //     reader.readAsText(fileToRead);
    //     // Handle errors load
    //     reader.onload = this.fileReadingFinished;
    //     reader.onerror = this.errorHandler;
    // }
    // processData = (csv) => {
    //     console.log("processData.............")
    //     var allTextLines = csv.split(/\r\n|\n/);
    //     var lines = allTextLines.map(data => data.split(';'))

    //     console.log(lines)
    // }

    // fileReadingFinished = (event) => {
    //     console.log("fileReadingFinished...........")
    //     var csv = event.target.result;
    //     this.processData(csv);
    // }

    // errorHandler = (event) => {
    //     console.log("errorHandler...........")
    //     if (event.target.error.name === "NotReadableError") {
    //         alert("Cannot read file!");
    //     }
    // }
    render() {

        const { messenger, showDatePicker, tempScheduleTime, scheduleTimeError,
            messageConfig, timeData, pageCount, pageNumber, messangerList, messageSend,
            renderToDropBox, messageStatusDropBox, scheduleTODropBox, notificationStyleDropBox,fileName,
            selectedMessage, newMessage, showMessageinfo, view, selectedStatus, openDropBox } = this.state
        const selectedFromDate = moment(tempScheduleTime || new Date())

        return (
            <div >
                {this.state.loading && <Loading />}
                {messageSend ?
                    <div className="modal messageSend " id="myModal" role="dialog">
                        <div className="modal-dialog messageSend-dialog">
                            <div >
                                <i className="fa fa-check-circle fa-7x" style={{ color: 'green' }}></i>
                                <div style={{ fontSize: '25px', fontWeight: '600', color: 'black' }}>Well done!</div>
                                <div style={{ fontSize: '17px', fontWeight: '300', color: 'black' }}>Message has been scheduled successfully</div>
                            </div>
                        </div>
                    </div>

                    : <div className="modal btn-closeMessanger" data-dismiss="modal" id="mygamemessenger" role="dialog">
                        <div className="modal-dialog">


                            <div className="modal-content mg-messanger-modal">

                                {

                                    newMessage ?
                                        <NewMessage
                                            openDropBox={openDropBox}
                                            goBack={this.goBack}
                                            onDropFiles={(e) => this.onDropFiles(e)}
                                            messageStatusDropBox={messageStatusDropBox}
                                            renderToDropBox={renderToDropBox}
                                            scheduleTODropBox={scheduleTODropBox}
                                            messageConfig={messageConfig}
                                            timeData={timeData}
                                            fileName={fileName}
                                            onMessageChange={(e) => this.onMessageChange(e)}
                                            saveMessageConfiguration={(uploadInput) => this.saveMessageConfiguration(uploadInput)}
                                            onAccountNameChanges={(e) => this.onAccountNameChanges(e)}
                                            setSelectedValue={(e, value) => this.setSelectedValue(e, value)}
                                            clickOutside={(e, data) => this.clickOutside(e, data)}
                                            notificationStyleDropBox={notificationStyleDropBox}
                                            handleUpload={(e) => this.handleUpload(e)}
                                            openDropDown={(e, dropBox) => this.openDropDown(e, dropBox)} />
                                        :
                                        showMessageinfo ?
                                            <MessageInformation
                                                selectedMessage={selectedMessage}
                                                messageinfo={this.messageinfo}
                                                goBack={this.goBack} />
                                            : <MessageList
                                                pageNumber={pageNumber}
                                                totalPage={pageCount}
                                                filter={filter}
                                                selectedValue={selectedStatus}
                                                openDropBox={openDropBox}
                                                handleClose={(close) => this.props.handleClose(false)}
                                                closeMyGameMessanger={this.closeMyGameMessanger}
                                                openDropDown={(e, dropBox) => this.openDropDown(e, dropBox)}
                                                createNewMessage={this.createNewMessage}
                                                messageinfo={(e, data) => this.messageinfo(e, data)}
                                                clickOutside={(e, data) => this.clickOutside(e, data)}
                                                setSelectedValue={(e, value) => this.setSelectedValue(e, value)}
                                                messangerList={messangerList}
                                                nextPage={(selectedPage) => this.nextPage(selectedPage)}
                                            />
                                }

                            </div>

                        </div>
                    </div>
                }


                {/* <Dialog
                    contentStyle={{ width: '638px', marginBottom: '30px', maxWidth: 'none', backgroundColor: 'white', marginTop: '-50px' }}
                    bodyStyle={{ backgroundColor: "white", width: '638px', padding: '20px' }}
                    title={this.props.title}
                    modal={true}
                    bodyClassName="mg-messanger-body"
                    open={this.props.open}
                    onRequestClose={this.handleClose}
                    autoScrollBodyContent={false}
                > */}
                {/* {
                        newMessage ?
                            <NewMessage
                                openDropBox={openDropBox}
                                goBack={this.goBack}
                                openDropDown={this.openDropDown} />
                            :
                            showMessageinfo ?
                                <MessageInformation
                                    selectedMessage={selectedMessage}
                                    messageinfo={this.messageinfo}
                                    goBack={this.goBack} />
                                : <MessageList
                                    pageNumber={pageNumber}
                                    pageCount={pageCount}
                                    filter={filter}
                                    selectedValue={selectedValue}
                                    openDropBox={openDropBox}
                                    openDropDown={this.openDropDown}
                                    createNewMessage={this.createNewMessage}
                                    messageinfo={(e, data) => this.messageinfo(e, data)}
                                    clickOutside={(e, data) => this.clickOutside(e, data)}
                                    setSelectedValue={(e, value) => this.setSelectedValue(e, value)}
                                    messangerList={messangerList}
                                />
                    } */}

                {/* </Dialog> */}
            </div>
        )
    }
}

export default MyGameMessenger2


/** WEBPACK FOOTER **
 ** ./src/components/MyGameMessanger2/index.js
 **/